import BusinessGroup from './group';

export default BusinessGroup;
